import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 145,
	height: 145,
	viewBox: "0 0 145 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M72.395 143.435C111.629 143.435 143.435 111.629 143.435 72.395C143.435 33.1607 111.629 1.35498 72.395 1.35498C33.1607 1.35498 1.35498 33.1607 1.35498 72.395C1.35498 111.629 33.1607 143.435 72.395 143.435Z",
			stroke: "white",
			strokeWidth: 2.71,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.5849 43.575C81.2549 43.575 88.3049 50.625 88.3049 59.295C88.3049 67.965 81.2549 75.015 72.5849 75.015C63.9149 75.015 56.8649 67.965 56.8649 59.295C56.8649 50.625 63.9149 43.575 72.5849 43.575ZM72.5849 35.805C59.6049 35.805 49.085 46.325 49.085 59.305C49.085 72.285 59.6049 82.805 72.5849 82.805C85.5649 82.805 96.0849 72.285 96.0849 59.305C96.0849 46.325 85.5649 35.805 72.5849 35.805Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.595 108.335C46.985 97.295 58.915 89.865 72.595 89.865C86.275 89.865 98.205 97.295 104.595 108.335",
			stroke: "white",
			strokeWidth: 7.78,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCustomersIcon;
